import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { HomePageEffects } from './home-page.effects';

@NgModule({
  imports: [EffectsModule.forFeature([HomePageEffects])],
})
export class HomePageStoreModule {}
